export const LANGUAGES = ['Hindi', 'English', 'Telugu', 'Tamil', 'Marathi', 'Kannada']

export const CNC_ERROR_CODES = [
  'NA',
  '2040x1 :Dock Door is closed twice before Special CAN ID is detected',
  '2615:Successfully completed Battery Swap.',
  '2010:Failed to unlock mQIS dock door. Please call Agent. during/after inserting battery 1',
  '2039x1 :Special CAN ID detection is failed',
  '2006:Insufficient number 1 of free docks to place depleted batteries',
  '2006 : Empty dock unavailable, during the station readiness check.',
  '2048x1 :Empty dock unavailable, after the station readiness check.',
  '2034x1 :Depleted BP SOC Threshold Check is Failed',
  '2024 : Special CAN ID before swap.',
  '2043x1 : Dispensed BP Removal Check Failed',
  '2007:Failed to find a full charged supported Battery Packs for this vehicle. Please call Agent.',
  '2007: No dispensable BPs found.',
  '2007: No early dispensable BPs also found.',
  '2036x1 :Possible BP Theft Identified',
  '2023x1 :CANID assignement failed.',
  '2019:DockId from battery doesnot match with keyfob.',
  '2028:Vehicle VIN is blacklisted as per the Check Swap API Response.',
  '2038x1 : Dispensed BP Door Close Check Failed',
  '2037x1 :Inserted BP Door Close Check Failed',
  '2011x1 :Error in detecting mQIS dock door lock status. Please call Agent.',
  '2012x1 :Failed to detect mQIS dock door as locked. Please call Agent.',
  '2014:Failed to determine Depleted BP SoCs',
  '2101:Low Balance, Please Recharge.',
  '2046:Vehicle VIN is blacklisted as per the Keyfob.',
  '2044:Issue in changing the bluetooth hostname to Totp',
  '2025:Battery orchestrator service failed.',
  '2029:Check Swap API indicated to Disallow the Swap.',
  '2045:Vehicle VIN is blacklisted as per the local database.',
  '2026:Doors opened before swap',
  '2103:Station offline.',
  '2103:Station offline: Update keyfob as it is not within time limit threshold of 10 mins.',
  '2027:PLC-GPIO has problem',
  '2055:Swap not allowed yet. Wait for the required time before retrying.',
  '2041x1 :Dock Door Unlock command for BP insertion is failed',
  '2052x1 :Battery communication failure.',
  '2053x1 : Battery communication failure, Battery is removed from station',
  '2051:Vehicle VIN is not found as per the Check Swap API Response.',
  '2030:There are no supported BPs found for this vehicle.',
  '2107:Walletapi Error: the response status is not 200, unsuccessful.',
  '2802:BLE Write Failed Twice.',
  '2057x1 :Mismatch: Inserted BP MDock ID does not match the customer keyfob MDock ID.',
  '2058:As per API, Swap is not eligible for this vehicle due to Time constraints.',
  '2109:Swap Eligibility Error: Error in processing the swap eligibility through the API.',
]

export const SERVICE_PROVIDERS = [
  'Rapido', 'Green Drive', 'Eveez', 'Shadowfax', 'HALA', 'NORTHERN IT', 'Zypp',
  'TripX', 'Moeving', 'ScooEV', 'Bykemania', 'Bike bazaar', 'Wickedride',
  'Dharma Logistics', 'FAE', 'Bluwheelz', 'DCO / BAAS', 'Bounce Infinity', 'Triev',
  'Omega', 'Porter', 'OSM', 'Loadshare', 'GO rent logistic', 'RR Mobility',
  'Hiral Techno', 'Laundrymate', 'Wheez', 'Zevo', 'Zepto', 'Blinkit', 'Zometo',
  'HRS', 'Others',
]

export const OEM_BRANDS = [
  'Vegh', 'Yatri', 'Unique', 'City Life', 'Mahindra', 'Arzoo', 'Quantum Energy',
  'TVS', 'Mayuri', 'Next Mobility', 'Victory', 'New Arcana India', 'Shema',
  'Sun Mobility', 'E-Mobi', 'Hero', 'Bajaj', 'Ok Play', 'Ampere', 'Piaggio',
  'Oye Rickshaw', 'BattRe', 'OSM', 'Jangid', 'Saarthi', 'Shehansah', 'Kinetic',
  'Goenka Prince', 'Galaxy', 'Saras', 'Pratham', 'Samrat', 'JMD Moters',
  'Twenty two motors Pvt. Ltd.', 'TATA Ace', 'Gravton Motors', 'Warivo', 'Bgauss',
  'Lectrix', 'NXT Mobility', 'Dilli Electric', 'Omega Seiki', 'Odysse', 'Tata',
  'Fujiyama', 'Skoot', 'Yamaha', 'Bounce Infinity', 'Xidda Moto', 'Green Tiger',
  'Greeves Electric', 'Motovolt', 'Revolt', 'Okaya', 'Lectrix EV', 'Retrofit Partner',
  'Atumobile', 'TATA Motors Limited', 'E Sathi', 'E- Sprinto green energy', 'Zypp',
  'Ape', 'HRS', 'Raftaar', 'Scoot EV', 'Verivo', 'Eagle', 'Ride EV', 'Other',
]

export const VEHICLE_AGES = [
  { value: '0_15_days',     label: '0–15 days' },
  { value: '15_30_days',    label: '15–30 days' },
  { value: '30_60_days',    label: '30–60 days' },
  { value: 'above_60_days', label: 'Above 60 days' },
]

export const PRIORITIES = [
  { value: 'urgent', label: 'Urgent' },
  { value: 'normal', label: 'Normal' },
]

export const CUSTOMER_TYPES = [
  { value: 'fleet',  label: 'Fleet' },
  { value: 'sales',  label: 'Sales' },
  { value: 'retail', label: 'Retail' },
  { value: 'dco',    label: 'DCO' },
]

export const CHANNELS = [
  { value: 'call',      label: 'Call' },
  { value: 'whatsapp',  label: 'WhatsApp' },
  { value: 'email',     label: 'Email' },
]

export const SOURCE_CHANNELS = [
  ...CHANNELS,
  { value: 'rider_app', label: 'Rider App' },
  { value: 'other',     label: 'Other' },
]

export const TICKET_TYPES = [
  { value: 'call_center',  label: 'Call Center' },
  { value: 'test',         label: 'Test' },
  { value: 'follow_up',    label: 'Follow Up' },
  { value: 'self_assign',  label: 'Self Assign' },
  { value: 'query',        label: 'Query' },
]

export const LOCATION_TYPES = [
  { value: 'station', label: 'Station' },
  { value: 'on_road', label: 'On Road' },
]

export const STATES = [
  'Delhi', 'Maharashtra', 'Karnataka', 'Telangana',
  'Tamil Nadu', 'Uttar Pradesh', 'Rajasthan',
]

/* ── ERT Ticket Closure form options ──
   Source of truth: ert_ticket_closure_flow.md — resolution_type splits the
   whole Step 2 field set (and its dropdown options) into "physical" vs "remote". */

export const ERT_SOC_OPTIONS = [
  '0%', '1-10%', '11-20%', '21-50%', '51-70%', '71-90%', '91-100%',
]

export const ERT_BP_CHECKED_AT_OPTIONS = [
  'Fresh Service Bug', 'In Client Hub', 'In SMPL Hub', 'Near by QIS', 'On Road',
]

export const ERT_TOOL_USED_OPTIONS = [
  'By Drill Tool', 'By G Force', 'By QIS BLE', 'NFC Phone/ Reader', 'No Swapped', 'SBA Tool', 'SBD Tool',
]

// tool_used_to_remove_bp values that make bd_id (Battery ID) required for physical closure
export const ERT_BD_ID_REQUIRED_TOOLS = ['SBD Tool', 'SBA Tool', 'By Drill Tool', 'NFC Phone/ Reader']

// actual_fault_found options — physical resolution
export const ERT_PHYSICAL_FAULT_OPTIONS = [
  'AFE Fault',
  'All Charge Flags are not set',
  'Battery Drop',
  'Battery Orphan',
  'Battery Switch Error',
  'BMCU Flashing BP',
  'Boot Switch Error',
  'Boot Switch shorted',
  'BP Addressing Failed in Vehicle',
  'BP Degradation High',
  'BP LED Not Working',
  'BP Quarantine',
  'BP Sound Coming',
  'BP Warning',
  'Capacity Due',
  'Capacity Warning',
  'Charge mode AC power OFF',
  'Connecting Issue - No Error code on SBA Screen',
  'Deep Discharged BP',
  'DIU 12V Output',
  'Dock ID Mismatched',
  'Dock Side Wiring Issue',
  'Dock Temperature Issue',
  'DV Drive',
  'EV Out Sense Malfunction',
  'Invalid Location (GPS)',
  'Lock sense fault',
  'MCU Communication',
  'Min cell voltage & DV Drive',
  'MOSFAT Malfunctions',
  'Mosfet Failure/ Malfunction',
  'No Error code on SBA Screen',
  'Over Voltage',
  'Power on Reset',
  'Precharge',
  'Ready to Swap',
  'Recover',
  'Removed by admin key fob',
  'Short Temperature',
  'Solenoid Fault',
  'State of Charge',
  'Stop BLE',
  'TBD',
  'TIU Communication Error',
  'TOTP Mismatch',
  'Unauthorized Unlock',
  'Under Voltage',
  'Vehicle Side Wiring Issue',
]

// actual_fault_found options — remote resolution
export const ERT_REMOTE_FAULT_OPTIONS = [
  'BP Damaged',
  'BP Error/ Vehicle not running with 100% SOC BP',
  'Dock Damaged',
  'Low SOC',
  'Multiple Times Key fob Tapping - Swap Done',
  'PCB Membrane Damaged',
  'Power NA in QIS',
  'Power Off',
  'Rider Go back to Hub/ Home',
  'Rider Not Contactable',
  'Self-Resolved',
  'Station Operator Not available',
  'Test Ticket',
  'Top Cover Broken',
  'Vehicle Key Fob Not Mapped',
  'Water Inside in Dock',
]
